module.exports = __webpack_public_path__ + "static/giantBottle-787bc677caec218bfe8d8efc7887381c.jpg";